'use client';

import { ErrorPage } from '@/layout/ErrorPage';

interface Props {
  error: Error & { digest?: string };
}

const GlobalErrorPage = (props: Props) => {
  const { error } = props;

  return (
    <html lang="de">
      <body>
        <ErrorPage error={error} />
      </body>
    </html>
  );
};

export default GlobalErrorPage;
